import { useTranslation as useTranslationI18n } from "react-i18next"

export function useTranslation(keyPrefix = "", options = {}) {
  const { t } = useTranslationI18n(undefined, { ...options, keyPrefix })

  return t
}
